import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import moment from "moment";
import { Bar } from "react-chartjs-2";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Brightness4OutlinedIcon from "@material-ui/icons/Brightness4Outlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Typography } from "@material-ui/core";
import {
  getInstructorLocation,
  getGeo,
  getGeoDistance,
  setOverrideStudent,
  setStudentOverrideRequest,
  setLock,
  setLockStudent,
  listenToLock
} from "../firebaseApi";
import LinearProgress from "@material-ui/core/LinearProgress";
import StudentLocked from "./StudentLocked";

const styles = (theme) => ({
  pollBackground: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  bar: {
    height: 320,
  },
  skeleton: {
    height: 320,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    border: "1px solid #afafaf",
    color: "#afafaf",
  },
  image: {
    height: 320,
  },
  overrideContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

function calculateDistance(lat1, lon1, lat2, lon2) {
  const earthRadius = 6371; // Earth's radius in kilometers

  const dLat = degToRad(lat2 - lat1);
  const dLon = degToRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(degToRad(lat1)) *
      Math.cos(degToRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = earthRadius * c; // Distance in kilometers
  return distance;
}

function degToRad(degrees) {
  return degrees * (Math.PI / 180);
}

function isStudentInClass(
  studentLat,
  studentLon,
  instructorLat,
  instructorLon,
  maxDistance
) {
  const distance = calculateDistance(
    studentLat,
    studentLon,
    instructorLat,
    instructorLon
  );
  return distance <= maxDistance;
}

function StudentPoll(props) {
  let urlParams = props.match.params;
  const [showColor, setShowColor] = React.useState(false);
  const [studentLocation, setStudentLocation] = React.useState(false);
  const [showNotInClassDialog, setShowNotInClassDialog] = React.useState(false);
  const [showNoAccess, setShowNoAccess] = React.useState(false);
  const [showOverrideDialog, setShowOverrideDialog] = React.useState(false);
  const [showRequestSent, setShowRequestSent] = React.useState(false);
  const [checkStudent, setCheckStudent] = React.useState(false);
  const [overriden, setOverriden] = React.useState(false);
  //const [voteChangeDialog, setVoteChangeDialog] = React.useState(true);
  const [graphDataInfo, setGraphDataInfo] = React.useState(null);
  //const [waitDisplayPoll, setWaitDisplayPoll] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [pollLive, setPollLive] = React.useState(false);
  const [overrideApprovedDialog, setOverrideApprovedDialog] = React.useState(false);
  const [lock, setShowLock] = React.useState(false);

  let mobile = props.width === "sm" || props.width === "xs";

  function getPollData(students, categoryName, optionNames) {
    let data = {
      Total: [0, 0, 0, 0, 0],
    };

    if (categoryName !== null) {
      for (let optionName of optionNames) {
        data[optionName] = [0, 0, 0, 0, 0];
      }
      data["Unknown"] = [0, 0, 0, 0, 0];
    }

    // Fulfill datasets with poll results
    if (Object.values(students).length) {
      for (let student of Object.values(students)) {
        // Get the student's answer and categories
        let studentVote = student.studentVote;
        let studentCategories = student.studentCategories;

        // Check whether the answer is valid or not
        studentVote = studentVote.replace("X", "");
        let studentVoteIndex = ["A", "B", "C", "D", "E"].indexOf(studentVote);
        if (studentVoteIndex === -1) {
          continue;
        }

        data["Total"][studentVoteIndex]++;

        if (categoryName !== null) {
          // Get the student's option in category
          let optionName = studentCategories[categoryName];

          // Student's default option is 'Unknown'
          optionName = optionName === undefined ? "Unknown" : optionName;

          // Increment the count of the answer in the student's option by 1
          data[optionName][studentVoteIndex]++;
        }
      }
    }

    return data;
  }

  function getGraphData(pollData) {
    let datasets = [
      {
        label: "No Data",
        data: [0, 0, 0, 0, 0],
      },
    ];

    let sum = 0;
    for (let subTotal in pollData["Total"]) {
      sum += pollData["Total"][subTotal];
    }

    if (Object.keys(pollData).length !== 0) {
      // If the poll is not empty, delete the default option
      datasets.splice(0, 1);

      let restCount = Array.from(pollData["Total"]);

      if (props.poll.answer) {
        let idx = ["A", "B", "C", "D", "E"].indexOf(props.poll.answer);
        let data = [0, 0, 0, 0, 0];
        data[idx] = (pollData["Total"][idx] / sum) * 100;

        datasets.push({
          label: "Correct",
          data: data,
          backgroundColor: "#00bf008f",
        });

        restCount[idx] = restCount[idx] - pollData["Total"][idx];
      }

      datasets.push({
        label: "Rest",
        data: restCount.map((count) => Math.ceil((count / sum) * 100)),
      });
    }

    return {
      labels: ["A", "B", "C", "D", "E"],
      datasets,
    };
  }

  let voteButtons = (fullWidth) => (
    <ButtonGroup fullWidth={fullWidth}>
      {["A", "B", "C", "D", "E"].map((choice) => (
        <Button
          key={choice}
          disabled={!pollLive}
          color={
            !props.course?.courseActivitySessionID && loading
              ? "default"
              : (props.vote.replace("X", "") === choice || props.vote.replace("L","") === choice)
              ? "primary"
              : "default"
          }
          variant={
            !props.course?.courseActivitySessionID && loading
              ? "outlined"
              : (props.vote.replace("X", "") === choice || props.vote.replace("L","") === choice)
              ? "contained"
              : "outlined"
          }
          style={
            props?.poll?.pollAnonymous && pollLive
              ? {
                  backgroundColor:
                    !pollLive && loading
                      ? "black"
                      : (props.vote.replace("X", "") === choice || props.vote.replace("L","") === choice)
                      ? "#1976d2"
                      : "black",
                  color: "white",
                  borderColor: "white",
                  borderWidth: "1px",
                  borderStyle: "solid",
                }
              : null
          }
          onClick={async () => {
            const currPoll = props.poll.pollID;

            try {
              let data = {
                sessionID: props.session.sessionID,
                studentID: props.account.accountID,
                firstName: props.account.accountFirstName,
                lastName: props.account.accountLastName,
                email: props.account.accountEmail,
              };
              props.setVote(choice);
              let mystudentID = props.account.accountID;
              const geoloc = !props.session.geoInactive ? await getGeo(urlParams.courseID) : null;
              const geoDis = !props.session.geoInactive ? await getGeoDistance(urlParams.courseID): null;

              if (geoloc && !props.session.geoInactive) {
                setStudentLocation(true);

                const { latitude, longitude } =
                  await props.handleStudentGeolocation();

                //alert(JSON.stringify({ latitude, longitude }));

                // alert(urlParams.courseID);

                const { instructorLatitude, instructorLongitude } =
                  await getInstructorLocation(urlParams.courseID);

                // alert(JSON.stringify({ instructorLatitude, instructorLongitude }));

                let maxDistanceThreshold = geoDis || 0.3;
                const isInClass = isStudentInClass(
                  latitude,
                  longitude,
                  instructorLatitude,
                  instructorLongitude,
                  maxDistanceThreshold
                );

                // alert(JSON.stringify({ isInClass }));

                setStudentLocation(false);

                if (isInClass || overriden) {
                 
                    props.poll.pollAnonymous
                      ? props.setVote("X" + choice)
                      : props.setVote(choice);
                    if(props.poll.pollLock || (props.course.students[mystudentID] && props.course.students[mystudentID].locked === "1")){
                      if(props.course.students[mystudentID] && props.course.students[mystudentID].locked !== "1"){
                        setLock({accountID:props.account.accountID,courseID:props.course.courseID,locked:"1",sessionID: props.course.courseActivitySessionID, pollID: currPoll})
                      }
                      setShowLock(true);
                      props.setVote("L" + choice)
                      setLockStudent(data, (firstStudent) => {
                        if (firstStudent) {
                          props.refreshSessionListen();
                        }
                      });
                    } 

                  
                } else if (!isInClass) {
                  setShowNotInClassDialog(true);
                  
                    props.poll.pollAnonymous
                      ? props.setVote("XG" + choice)
                      : props.setVote("G" + choice);
                      if(props.poll.pollLock || (props.course.students[mystudentID] && props.course.students[mystudentID].locked === "1")){
                        if(props.course.students[mystudentID] && props.course.students[mystudentID].locked !== "1"){
                          setLock({accountID:props.account.accountID,courseID:props.course.courseID,locked:"1",sessionID: props.course.courseActivitySessionID, pollID: currPoll})
                        }
                        setShowLock(true);
                        props.setVote("L" + choice);
                        setLockStudent(data, (firstStudent) => {
                          if (firstStudent) {
                            props.refreshSessionListen();
                          }
                        });
                    } 
                  
                  let data = {
                    sessionID: props.session.sessionID,
                    studentID: props.account.accountID,
                    firstName: props.account.accountFirstName,
                    lastName: props.account.accountLastName,
                    email: props.account.accountEmail,
                  };
                  setOverrideStudent(data, (firstStudent) => {
                    if (firstStudent) {
                      props.refreshSessionListen();
                    }
                  });
                  
                }
              } else {
                
                  props.poll.pollAnonymous
                    ? props.setVote("X" + choice)
                    : props.setVote(choice);
                  if(props.poll.pollLock || (props.course.students[mystudentID] && props.course.students[mystudentID].locked === "1")){
                    if(props.course.students[mystudentID] && props.course.students[mystudentID].locked !== "1"){
                      setLock({accountID:props.account.accountID,courseID:props.course.courseID,locked:"1",sessionID: props.course.courseActivitySessionID, pollID: currPoll, vote: choice + " (normal vote)"})
                    }
                      props.setVote("L" + choice);
                      setShowLock(true);
                      setLockStudent(data, (firstStudent) => {
                        if (firstStudent) {
                          props.refreshSessionListen();
                        }
                      });
                  } 
              }
            } catch (err) {
              console.log(err);
              if (overriden) {

                  props.poll.pollAnonymous
                    ? props.setVote("X" + choice)
                    : props.setVote(choice);
                
              } else {
                setStudentLocation(false);
                setShowNoAccess(true);
                  props.poll.pollAnonymous
                    ? props.setVote("XG" + choice)
                    : props.setVote("G" + choice);
                  if(props.poll.pollLock || (props.course.students[props.account.accountID] && props.course.students[props.account.accountID].locked === "1")){
                    if(props.course.students[props.account.accountID] && props.course.students[props.account.accountID].locked !== "1"){
                      setLock({accountID:props.account.accountID,courseID:props.course.courseID,locked:"1",sessionID: props.course.courseActivitySessionID, pollID: currPoll, vote: choice + " (error: " + err})
                    }
                      setShowLock(true);
                      props.setVote("L" + choice)
                      setLockStudent(data, (firstStudent) => {
                        if (firstStudent) {
                          props.refreshSessionListen();
                        }
                      });
                  } 
                let data = {
                  sessionID: props.session.sessionID,
                  studentID: props.account.accountID,
                  firstName: props.account.accountFirstName,
                  lastName: props.account.accountLastName,
                  email: props.account.accountEmail,
                };
                setOverrideStudent(data, (firstStudent) => {
                  if (firstStudent) {
                    props.refreshSessionListen();
                  }
                });
              }
            }
          }}
        >
          {choice}
        </Button>
      ))}
    </ButtonGroup>
  );

  // Loading screen in order to get graph data before displaying poll
  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    if (props.showDisplay && props.poll) {
      setLoading(true);
      let data = getGraphData(getPollData(props.poll.students, null, null));
      setGraphDataInfo(data);
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
    if (!props.showDisplay) {
      setLoading(true);
    }
  }, [props.showDisplay, props.poll]);
// eslint-disable-enable react-hooks/exhaustive-deps

  // Function to clear the voting bar before showing so that previous vote is not shown
  React.useEffect(() => {
    if (props.live) {
      setTimeout(() => {
        setPollLive(true);
      }, 200);
    } else {
      setPollLive(false);
    }
  }, [props.live]);
  
  React.useEffect(()=>{
    if (props.course.courseID && props.course.accountEmail) {
      let data = {courseID: props.course.courseID, studentID: props.account.accountEmail}
      const unsubscribe = listenToLock(data, setShowLock);
      return () => unsubscribe();
    }
  },[])

  // Geolocation Override
  React.useEffect(() => {
    if (props?.session?.students?.length > 0) {
      for (const overStudent of props.session.students) {
        if (overStudent.email === props.account.accountEmail) {
          if (overStudent?.overriden) {
            setOverriden(true);
          } else {
            setCheckStudent(true);
            setOverriden(false);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.session]);

  // Remove geolocation overriden when course is switched
  React.useEffect(() => {
    if (urlParams.courseID || !props.course?.courseActivitySessionID) {
      setOverriden(false);
    }
  }, [urlParams.courseID, props.course?.courseActivitySessionID]);

  return (
    <div>
      {!(props.poll?.pollAnonymous && pollLive) ? null : (
        <div
          className={props.classes.overrideContainer}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <Typography
            style={{
              fontSize: "x-large",
              backgroundColor: "black",
              color: "white",
              padding: "5px 10px 5px 10px",
              borderRadius: "10px",
            }}
          >
            Anonymous Poll
          </Typography>
          <Typography
            style={{
              fontSize: "medium",
              backgroundColor: "black",
              color: "white",
              padding: "5px 10px 5px 10px",
              borderRadius: "10px",
            }}
          >
            This vote will not be seen by the instructor
          </Typography>
        </div>
      )}

      <Card className={props.classes.pollBackground} elevation={0}>
        <ListItem>
          <ListItemAvatar>
            <Avatar style={{ borderRadius: 0 }}></Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={
              props.poll
                ? moment(Number(props.poll.pollStartTime)).format(
                    "ddd, MMM Do YYYY, H:mm"
                  )
                : "Please Wait"
            }
          />

          {studentLocation ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              <LinearProgress
                color="secondary"
                style={{ width: 100, marginRight: 10 }}
              />
            </div>
          ) : null}

          {!props.vote ? null : (
            <IconButton
              onClick={() => {
                setShowColor(true);
              }}
            >
              <Brightness4OutlinedIcon />
            </IconButton>
          )}
          {mobile ? null : voteButtons(false)}
        </ListItem>

        {!mobile ? null : <ListItem>{voteButtons(true)}</ListItem>}

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          {loading ? (
            <Grid item md={6} xs={12}>
              <div className={props.classes.skeleton}>
                <Typography>Nothing to View</Typography>
              </div>
            </Grid>
          ) : (
            <Grid item md={6} xs={12}>
              <Paper className={props.classes.bar} elevation={0}>
                <Bar
                  data={graphDataInfo}
                  redraw={true}
                  options={{
                    maintainAspectRatio: false,
                    animation: false,
                    scales: {
                      xAxes: [
                        {
                          stacked: true,
                        },
                      ],
                      yAxes: [
                        {
                          stacked: true,
                          suggestedMin: 0,
                          ticks: {
                            min: 0,
                            max: 100,
                            callback: (value) => value + "%",
                          },
                        },
                      ],
                    },
                  }}
                  legend={{ display: false }}
                />
              </Paper>
            </Grid>
          )}
        </Grid>
      </Card>

      <Divider />

      {props.session.sessionOverrideLive &&
      checkStudent &&
      props.course?.courseActivitySessionID &&
      !overriden ? (
        <div
          className={props.classes.overrideContainer}
          style={{ marginTop: "10px" }}
        >
          <Button
            onClick={() => {
              setShowOverrideDialog(true);
            }}
            color="primary"
            variant="contained"
          >
            Request geolocation override
          </Button>
        </div>
      ) : null}

      {overriden && props.course?.courseActivitySessionID ? (
        <div
          className={props.classes.overrideContainer}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <Typography style={{ fontSize: "large" }}>
            Geolocation override approved
          </Typography>
          <IconButton
            variant="outlined"
            color="primary"
            onClick={() => {
              setOverrideApprovedDialog(true);
            }}
          >
            <InfoOutlinedIcon />
          </IconButton>

          <Dialog
            open={overrideApprovedDialog}
            onClose={() => {
              setOverrideApprovedDialog(false);
            }}
          >
            <DialogContent>
              <Typography>
                The instructor approved your geolocation override request. You
                can now vote in this session. Also, all your earlier votes in
                this session have been counted, even when you get the location
                error. Please note that the geolocation override is only valid
                for this current session.
              </Typography>
            </DialogContent>
            <Button
              onClick={() => {
                setOverrideApprovedDialog(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </Dialog>
        </div>
      ) : null}
      <StudentLocked
        open={lock}
        openCtl={(open) => {
          //props.unselect();
          setShowLock(open);
        }}
        course={props.course}
      />
      {!props.session.sessionOverrideLive ? null : (
        <Dialog
          fullScreen={mobile}
          fullWidth
          maxWidth="sm"
          open={showOverrideDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return;
            }
          }}
        >
          <DialogContent>
            <Typography variant="h6" style={{ marginBottom: "16px" }}>
              Request geolocation override for the current session. This request
              will be sent to the instructor.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                setShowOverrideDialog(false);
              }}
            >
              Close
            </Button>
            <Button
              color="primary"
              onClick={() => {
                let data = {
                  sessionID: props.session.sessionID,
                  studentID: props.account.accountID,
                  overrideRequest: true,
                };
                setStudentOverrideRequest(data);
                setShowOverrideDialog(false);
                setShowRequestSent(true);
              }}
            >
              Send
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {!props.session.sessionOverrideLive ? null : (
        <Dialog
          fullScreen={mobile}
          fullWidth
          maxWidth="sm"
          open={showRequestSent}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return;
            }
          }}
        >
          <DialogContent>
            <Typography variant="h6" style={{ marginBottom: "16px" }}>
              The override request has been sent
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                setShowRequestSent(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {!props.poll ? null : (
        <Dialog
          fullScreen={mobile}
          fullWidth
          maxWidth="md"
          open={showColor}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return;
            }
          }}
        >
          <DialogContent
            style={{
              backgroundColor: props.poll.pollVotedColor,
              height: "100vh",
            }}
          ></DialogContent>

          <DialogActions
            style={{
              backgroundColor: props.poll.pollVotedColor,
            }}
          >
            <Button
              onClick={() => {
                setShowColor(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {!props.poll ? null : (
        <Dialog
          fullScreen={mobile}
          fullWidth
          maxWidth="sm"
          open={showNotInClassDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return;
            }
          }}
        >
          <DialogContent>
            <Typography variant="h6" style={{ marginBottom: "16px" }}>
              You are too far from the instructor's base-station!
            </Typography>
            <Typography>
              Please move to a location closer to the instructor and try again.
              If you are in the same room as the instructor and this issue
              persists, let them know and they can grant an override.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                setShowNotInClassDialog(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {!props.poll ? null : (
        <Dialog
          fullScreen={mobile}
          fullWidth
          maxWidth="sm"
          open={showNoAccess}
          onClose={(event, reason) => {
            if (reason === "backdropClick") {
              return;
            }
          }}
        >
          <DialogContent>
            <Typography variant="h6" style={{ marginBottom: "16px" }}>
              Location Access Denied!
            </Typography>
            <Typography>
              The instructor of this course requires you to share your location
              with the application to ensure that students are present in the
              session.
            </Typography>

            <div style={{ padding: "16px" }}></div>

            <Typography>
              Please enable location access through your devices settings then
              make sure to close the brower window and try again.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                setShowNoAccess(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(withStyles(styles, { withTheme: true })(withWidth()(StudentPoll)))
);
